import React from "react";
import { reportErrorToSupport } from "./GlobalErrorBoundary";

interface Props {
  children: React.ReactNode;
  label?: string;
}

interface State {
  error: Error | null;
}

export class SectionErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    reportErrorToSupport({
      message: `[${this.props.label ?? "section"}] ${error.message ?? "Unknown render error"}`,
      stack: error.stack ?? "",
      componentStack: info.componentStack ?? "",
      url: window.location.href,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      type: "render",
    }).catch(() => {});
  }

  render() {
    if (this.state.error) {
      return (
        <div className="rounded-lg border border-red-200 dark:border-red-800 bg-red-50 dark:bg-red-900/20 p-4 text-sm text-red-700 dark:text-red-400 flex items-start gap-3">
          <i className="fa-solid fa-triangle-exclamation mt-0.5 shrink-0" aria-hidden="true" />
          <div>
            <div className="font-medium">
              {this.props.label ? `${this.props.label} failed to load` : "This section failed to load"}
            </div>
            <div className="text-xs mt-1 opacity-75">{this.state.error.message}</div>
            <button
              className="mt-2 text-xs underline hover:no-underline"
              onClick={() => this.setState({ error: null })}
            >
              Try again
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
